export const GRAPH_MARGIN = 20;
